import React from 'react'
import '../styles.css'
import calendarIcon from '../../../../assets/icons/calendar-icon.svg'
import { Button, Tag, DatePicker, Dropdown, Menu, Modal } from 'antd'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { getReminders, updateNotes } from '../../../../redux/actions'
import { useEffect } from 'react'
import { useState } from 'react'
import { set } from 'lodash'
import Notes from '..';
import { useLocation } from "react-router-dom";

const NotesForm = ({ data, selecteNote, setOpenModal, openModal ,setOpenCalendarV, openCalendarV , onChageCal }) => {

    const location = useLocation();
    const [wordCount, setWordCount] = React.useState(0);
    const [notes, setNotes] = React.useState(null);
    // const [openCalender, onChageCal] = React.useState(false);
    const [startDate, setStartDate] = React.useState();
    const [endDate, setEndDate] = React.useState(null);
    const [notesD, setNotesD] = useState(null)
    const[dateD ,setdateD]= useState(null)
    const [visible,setVisible]=useState()
    const [errors, setErrors] = React.useState({
        notes: false,
        date: false
    });
    
    useEffect(() => {
        // onChageCal(openCalendarV);
        if (!openModal) {
            onChageCal(false)
        }
    }, [openModal]);

    useEffect(() => {   
        setNotes(selecteNote.Note)
        setEndDate(selecteNote.NoteEndTime || selecteNote.EndTime)
    }, [selecteNote])

    const { RangePicker } = DatePicker;
    const dispatch = useDispatch()
    
    const finishForm = () => {
        if (endDate && notes) {
            dispatch(updateNotes({
                SkillListingId: data?.length > 0 && data[0].SkillListingId,
                StartTime: startDate,
                EndTime: endDate,
                Note: notes,
                noteId: selecteNote?._id
            }))
            setOpenModal(false)
            setNotes(null)
            setEndDate(null)
            setErrors({ ...errors, notes: false })
            setErrors({ ...errors, date: false })
            // dispatch(getReminders())     
        }
        else {
            if (!notes) {
                setErrors({ ...errors, notes: true })
            }
            else if (!endDate) {
                setErrors({ ...errors, date: true })
            }
        }
        onChageCal(false)
    }

    return (
        <div className='notes-main-modal' >
            <textarea
                className={wordCount >= 250 && 'notes-textarea-error'}
                rows={6}
                onChange={(e) => {
                    setWordCount(e.target.value.length);
                    setNotes(e.target.value)
                }}
                maxlength={250}
                placeholder='Write your notes here'
                defaultValue={selecteNote.Note}
            />
            <div className='notes-textarea-counts'>
                <span id="Ratings-current-word-count">{wordCount}</span>
                <span id="Ratings-maximum-word-count"> / 250</span>
            </div>

            {(wordCount === 250 || errors.notes) ?
                <div style={{ marginTop: '3%', color: '#fc5c5c' }}>
                    {errors.notes ? 'Please add notes' : 'Can’t add more characters'}
                </div> : null}

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '38px' }}>
                <div>
                    <Button className={!errors.date ? 'reminder-btn' : 'reminder-btn-ERROR'}
                        onClick={() => {
                            onChageCal(!openCalendarV)
                        }}
                        icon={<img src={calendarIcon} style={{ marginRight: '4%', marginTop: '-5px' }} />}>
                        Set Reminder
                    </Button>
                    <DatePicker open={openCalendarV}
                        style={{ zIndex: '-1', position: 'absolute' }}
                        placement={'bottomRight'}
                        defaultValue={moment()}
                        visible={visible}
                        onClickOutside={() => setVisible(false)}
                        onChange={(e) => {
                            setStartDate(moment(e._d).toISOString())
                            setEndDate(moment(e._d).toISOString())
                            setTimeout(() => {
                                onChageCal(false)
                            }, [200])
                        }}
                       
                        
                        disabledDate={(current) => {
                            return moment().add(-1, 'days') >= current
                        }}
                    />
                </div>
                <div className='notes-button-row'>
                    <button id='btn1' onClick={() => { 
                        onChageCal(false);
                        setTimeout(() => {
                        setOpenModal(false);
                           
                          }, [500]);
                        
                    }}>Cancel</button>
                    <button id='btn2' onClick={finishForm}>Update</button>
                </div>
            </div>
        </div>
    )
}
export default NotesForm